/* Returns 'Unknown' if the Author field is null Note: could be used for any field */
angular.module('MW.InsDashboard.CheckAuthor',[]).filter('checkAuthor', function () {
        return function (input) {
            return (typeof input === 'undefined' || input === null || input === "") ? 'Unknown' : input;
        };
    });

/* Converts Sentiment values to undestandable symbols */
insDashboardApp.filter('checkmark', function () {
    return function (input) {
        var output = input;
        if (input ==='V') {
          output = '\u2639';
        }
        if(input === 'N') {
          output = '\u263A';
        }
        if(input === 'P') {
          output = '-';
        }
        if(input === 'D') {
          output = '-';
        }

        return output;
      };
  });

/* Converts null fields to 'N/A' */
insDashboardApp.filter('checkNull', function () {
    return function (input) {
      return (input === null) ? 'N/A' : input;
    };
  });

/* Truncates long texts to defined length */
angular.module('MW.InsDashboard.TruncateText',[]).filter('truncateText', function () {
    return function (text, length, end) {
        if (isNaN(length)) {
          length = 100;
        }
        if (end === undefined) {
          end = '...';
        }
        if (text.length <= length || text.length - end.length <= length) {
          return text;
        }
        else {
          return String(text).substring(0, length-end.length) + end;
        }
      };
  });